import { ProductCardProp, ProductType } from '../../../types/product';
import Shimmer from './Shimmer';
import SmallStoreProductCard from './StoreProductCard/SmallStoreProductCard';
import { StoreProductCard } from './StoreProductCard/StoreProductCard';
import VoucherProductCard from './VoucherProductCard';
import SmallVoucherProductCard from './VoucherProductCard/SmallVoucherProductCard';

export const ProductCard = (productProp: ProductCardProp) => {
  // constants
  const { isLoading, product } = productProp || {};
  const { productType } = product || {};

  if (isLoading) {
    return (
      <Shimmer
        rootStyle={{
          minWidth: '180px',
        }}
      />
    );
  }

  switch (productType) {
    case ProductType.Virtual: {
      const { isSmall } = productProp;
      if (isSmall) return <SmallVoucherProductCard {...productProp} />;
      return <VoucherProductCard {...productProp} />;
    }
    default: {
      const { isSmall } = productProp;
      if (isSmall) return <SmallStoreProductCard {...productProp} />;
      return <StoreProductCard {...productProp} />;
    }
  }
};
